export default "__VITE_ASSET__DlwO76eO__"